module.exports = __webpack_public_path__ + "Poppins-Medium.5bfdccef795165b1f9ab.ttf";


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Uclics/demo/angular/src/assets/fonts/Poppins-Medium.ttf
// module id = ../../../../../src/assets/fonts/Poppins-Medium.ttf
// module chunks = styles